import React from 'react'
import { dataGridColumn } from './DataGridColumn';
import CustomMenu from '../../components/Menu';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';

export const ToggleColumnMenu = ({ anchorEl, open, setAnchorEl, selectedColumn, setSelectedColumn,handleSelectColumn }) => {
    return (
        <>
            <CustomMenu
                id="user-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(false)}
                className="assign-board-owner-list">
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={Object?.values(selectedColumn)?.every(
                                    (value) => value === true
                                )}
                                onChange={() =>
                                    setSelectedColumn((prevObj) => {
                                        // Create a new object with all values set to true
                                        const newObj = Object?.keys(prevObj)?.reduce(
                                            (acc, key) => {
                                                acc[key] = true;
                                                return acc;
                                            },
                                            {}
                                        );
                                        return newObj;
                                    })
                                }
                            />
                        }
                        label="Select All"
                    />
                    {
                        dataGridColumn.filter(column => !["col1", "col2"].includes(column.field)).map((column, index) => (
                            <FormControlLabel
                                key={`watching-table-column-${index}`}
                                control={
                                    <Checkbox
                                        checked={selectedColumn[column.field]}
                                        onChange={() => handleSelectColumn(column.field)}
                                    />
                                }
                                label={column.headerName}
                            />
                        ))
                    }
                </FormGroup>
            </CustomMenu>
        </>
    )
}

